import sum from "lodash/sum";
import moment from "moment-timezone";
import orderBy from "lodash/orderBy";
import { calculatePercentCompleted as calculateKeyResultPercentCompleted } from "@/lib/keyResultUtil";

/**
 * Sums the KR completion percentages for a given goal, and distills it
 * to a single percentage number. Used to display HOW MUCH of a goal
 * has been completed.
 * @param {Goal} goal
 * @param {Array.<KeyResult>} keyResults = []
 * @returns {Number}
 */
export const calculatePercentCompleted = ( goal, keyResults = [] ) => {
	// if we've loaded key results, calculate completion percentage
	// based on those
	if ( keyResults.length > 0 ) {
		const completions = keyResults.map( keyResult => {
			return Math.min( 100, calculateKeyResultPercentCompleted( keyResult ) );
		} );
		const totalCompletion = sum( completions );
		return Math.floor( totalCompletion / completions.length );
	}

	// if we haven't yet loaded key results, calculate completion based
	// on goal metadata, if possible
	return goal.keyResultSummary?.progress || 0;
};

/**
 * Calculates the amount of time that has passed for a given goal and
 * distills it to a percentage. Used to display HOW LONG a given goal
 * has been in progress.
 * @param {Goal} goal
 * @param {String} timezone
 * @returns {Number}
 */
export const calculatePercentProgressed = ( goal, timezone ) => {
	const now = moment().tz( timezone );
	const start = moment.tz( goal.plannedStartDate, timezone );
	const finish = moment.tz( goal.plannedFinishDate, timezone );
	// eslint-disable-next-line no-magic-numbers
	const nowDiff = finish.diff( now, "days" );
	if ( nowDiff <= 0 ) {
		return 100;
	}
	const plannedDiff = finish.diff( start, "days" );
	return Math.floor( Math.max( 0, plannedDiff - nowDiff ) / plannedDiff * 100 );
};

/**
 * Consistent sorting algorithm for goals throughout the app
 * @param {Array.<Goal>}goals
 * @param {String} direction = "asc"
 * @returns {Array.<Goal>}
 */
export const sortGoals = ( goals, direction = "asc" ) => {
	return orderBy( goals, [ "plannedFinishDate", "created", "title", ], [ direction, direction, direction, ] );
};



// WEBPACK FOOTER //
// ./src/lib/goalUtil.js